// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".72988b5fd30c267c0dfb3e6f800abcf8.js";
};